import styled from 'styled-components';
import { DatePickerStyled } from '@/app/components/search/components/DatePickers/DatePicker/styled.ts';

export const CustomCalendarBodyContainer = styled.div`
  position: relative;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  margin: 16px;

  ${DatePickerStyled} {
    position: relative;
    top: 0;
    margin: 0;
    padding-bottom: 0;
  }
`;
